import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedCompanyMappingService } from '@wealthlane/api-services/wealthlane-identity-service';

const useDeleteAllowedMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void
): UseMutationResult<void, unknown, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: string) => {
      return await handleRequest(
        AllowedCompanyMappingService.deleteApiIdentityApiAppAllowedCompanyMapping(id)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null) {
          toast.success(<ToastComponent label='Success' message={`Company Mapping Deleted.`} />);
          await queryClient.invalidateQueries('getAllAllowedCompanyMappings');
        }
        onClose && onClose();
      },
      onError: (err) => {
        onClose && onClose();
        console.log('error', err);
      },
    }
  );
};

export default useDeleteAllowedMapping;
